import { createSlice } from "@reduxjs/toolkit";
import { getInvoiceById } from "./ThunkActions";
import { iInvoiceState, REDUCER_NAME } from "./Types"; 

// Define initial state based on the provided structure
const initialState: iInvoiceState = {
  isLoading: false,
  invoice: null, // Ensure this is a single object
  errorMessage: null,
};
export const invoiceSlice = createSlice({
  name: REDUCER_NAME, 
  initialState,
  reducers: {
    resetInvoiceState: () => {
      return initialState; // Reset to the initial state
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInvoiceById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getInvoiceById.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.invoice = payload.data.invoice; 
          state.isLoading = false;
        }
      })
      .addCase(getInvoiceById.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch invoice data";
        state.isLoading = false;
      });
  },
});

export const { resetInvoiceState } = invoiceSlice.actions;
export default invoiceSlice.reducer;
